document.addEventListener("DOMContentLoaded", function() {


    // Initialize standard horizontal accordions
    initializeStandardHorizontalAccordions();
    
    // Initialize single background horizontal accordions with different behavior
    initializeSingleBackgroundHorizontalAccordions();
    //initializeSingleAccordions()


    document.querySelectorAll('.accordion-button').forEach(function(button) {
        button.addEventListener('click', function() {
            setTimeout(() => {
                let accordionContentId = button.getAttribute('aria-controls');
                let accordionContent = document.getElementById(accordionContentId);
                // Check if the accordionContent is visible
                if (!accordionContent.style.display || accordionContent.style.display === 'block') {
                    // If visible, add the class
                    accordionContent.classList.add('bjm-accordion-open');
                } else {
                    // Otherwise, remove it
                    accordionContent.classList.remove('bjm-accordion-open');
                }
            }, 0); // This ensures it runs after all other click handlers
        });
    });

    // Function to check if the device width qualifies as a phone
    function isPhone() {
        var maxWidthForPhone = 768; // Define the maximum width for phones
        return window.innerWidth <= maxWidthForPhone;
    }

    // Initialize standard horizontal accordions if not on a phone
    function initializeStandardHorizontalAccordions() {
        if (!isPhone()) {
            var horizontalAccordions = document.querySelectorAll('.is-style-horizontal-accordion');
            initializeAccordions(horizontalAccordions);
        }
    }

    // Initialize single background horizontal accordions if not on a phone
    function initializeSingleBackgroundHorizontalAccordions() {
        if (!isPhone()) {
            var singleBackgroundAccordions = document.querySelectorAll('.is-style-horizontal-accordion-single-background');
            initializeAccordionsSingleImage(singleBackgroundAccordions);
        }
    }

    // Placeholder function for initializing numbered accordions
    function initializeSingleAccordions() {
        var otherAccordions = document.querySelectorAll('.bjm-numered-accordion .wp-block-blokki-content-accordion');
        initializeAccordionsSingle(otherAccordions);
    }

    // Initialize numbered accordions
    function initializeAccordionsSingle(accordions) {
        var counter = 1;
        accordions.forEach(function(accordion) {
            var accordionButtons = accordion.querySelectorAll('.accordion-button');
            // Loop through accordion buttons
            accordionButtons.forEach(function(button) {
                button.addEventListener('click', accordionSwitched);
                // //Deactivated due client requirements:
                // var existingH3 = button.querySelector('h3');
                // if (existingH3) {
                //     existingH3.parentNode.removeChild(existingH3);
                // }
                // var newH3 = document.createElement('h3');
                // newH3.innerHTML = counter < 10 ? '0' + counter + '.' : counter + '.';
                // button.insertBefore(newH3, button.firstChild);
                // counter++;
            });
        });
    }

    // Initialize standard accordions
function initializeAccordions(accordions) {
    accordions.forEach(function(accordion) {
        var firstAccordionCell = accordion.querySelector('.accordion-cell');
        if (firstAccordionCell) {
            firstAccordionCell.classList.add('open');
            var accordionContent = firstAccordionCell.querySelector('.accordion-content');
            if (accordionContent) {
                accordionContent.style.display = 'block'; // Ensure it's visible
                accordionContent.classList.add('open');
                accordionContent.classList.add('bjm-accordion-open');
            }
        }
        let accordionContainer = accordion.querySelectorAll('.accordion-content');
        let i = 0;
        accordionContainer.forEach(function(accordionContainerSingle){
            if(i>0){
                accordionContainerSingle.style.display='none'
            }
            i++
        })

        var accordionButtons = accordion.querySelectorAll('.accordion-button');
        var counter = 1;
        accordionButtons.forEach(function(button) {
            button.addEventListener('click', accordionSwitched)
            counter++;
        });
    });
}

// Initialize single background accordions with image
function initializeAccordionsSingleImage(accordions) {
    accordions.forEach(function(accordion) {
        var firstAccordionCell = accordion.querySelector('.accordion-cell');
        if (firstAccordionCell) {
            firstAccordionCell.classList.add('open');
            firstAccordionCell.classList.add('is-active');

            var accordionContent = firstAccordionCell.querySelector('.accordion-content');
            if (accordionContent) {
                accordionContent.style.display = 'block'; // Ensure it's visible
                accordionContent.classList.add('open');
                accordionContent.classList.add('bjm-accordion-open');
            }
        }

        var accordionButtons = accordion.querySelectorAll('.accordion-button');
        var counter = 1;
        accordionButtons.forEach(function(button) {
            button.addEventListener('click', accordionSwitchedSingleImage);
            counter++;
            // var accordionIcon = button.querySelector('.accordion-icon');
            // //Deactivated due client requirements:
            // var existingH3 = accordionIcon.querySelector('h3');
            // if (existingH3) {
            //     existingH3.parentNode.removeChild(existingH3);
            // }
            // accordionIcon.innerHTML += '<h3>0' + counter + '.</h3>';
            // counter++;
        });
    });
}


    // Handle switching of accordions
    function accordionSwitched(event) {
        var accordionContainer = this.closest('.is-style-horizontal-accordion');
        if (accordionContainer) {
            var allAccordionContents = accordionContainer.querySelectorAll('.accordion-content');
            allAccordionContents.forEach(function(content) {
                content.style.display = 'none';
                content.classList.remove('bjm-accordion-open');
            });
        }
    }

    // Handle switching of single image accordions
    function accordionSwitchedSingleImage(event) {
        var accordionContainer = this.closest('.is-style-horizontal-accordion-single-background');
        if (accordionContainer) {
            var allAccordionContents = accordionContainer.querySelectorAll('.accordion-cell');
            allAccordionContents.forEach(function(content) {
                var accordionContentSingleImage = content.querySelectorAll('.accordion-content');
                accordionContentSingleImage[0].style.display = 'none';
                content.classList.remove('is-active');
            });
        }
    }

});
